import type { UserListQuery } from '@/api/handlers/resources/users/requests';

/**
 * Centralised TanStack Query keys for the Users resource.
 *
 * `list()` is the prefix that covers every paginated page; `listPage` adds the
 * query params (page / pageSize / search / branchId) so each page is its own
 * cache entry. Write mutations invalidate `all` so every cached page refetches.
 */
export const UserQueryKeys = {
    all: ['users'] as const,
    list: () => [...UserQueryKeys.all, 'list'] as const,
    listPage: (query: UserListQuery) =>
        [...UserQueryKeys.list(), query] as const,
};
